import React from "react";
import PreImage from "../../../components/PreImage";

const BannerDisplay = ({ image, width, height, is_authorized=true }) => {
    const w = String(width || "800").replace(/\D/g, "");
    const h = String(height || "530").replace(/\D/g, "");

    const ratio = `${w} / ${h}`;

    return (
        <div className={`banner-preview ${!is_authorized && "non-authorized"}`} style={{ aspectRatio: ratio }}>
            <PreImage
                src={image || "no"}
                width={w}
                height={h}
                noPhoto={false}
                is_authorized={is_authorized}
            />
        </div>
    );
};

export default BannerDisplay;
